import { PortalError } from './PortalError';

export class NetworkError extends PortalError {
  constructor() {
    super('NetworkError', `No connection to a network`);
  }
}
